module.exports = __webpack_public_path__ + "img/change_7.ef7125b5.png";